<h2 mat-dialog-title>Potwierdzenie usunięcia</h2>

<mat-dialog-content>
	@if (error()) {
		<div class="alert alert-danger mb-3" role="alert">
			<i class="fas fa-exclamation-triangle"></i> {{ error() }}
		</div>
	}

	<p>Czy na pewno chcesz usunąć tę stawkę?</p>
	<div class="rate-details">
		<p>
			<strong>Okres:</strong> {{ data.rate.dateFrom | formatDateTime }} -
			{{ (data.rate.dateTo | formatDateTime) || 'bez końca' }}
		</p>
		<p><strong>Stawka:</strong> {{ data.rate.rate | price }} PLN</p>
		@if (data.rate.comments) {
			<p><strong>Uwagi:</strong> {{ data.rate.comments }}</p>
		}
	</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button (click)="onCancel()" [disabled]="isDeleting()" mat-raised-button>Anuluj</button>
	<button (click)="onConfirm()" [disabled]="isDeleting()" color="warn" mat-raised-button>
		@if (isDeleting()) {
			<mat-spinner diameter="20" style="display: inline-block; margin-right: 8px"></mat-spinner>
		}
		{{ isDeleting() ? 'Usuwanie...' : 'Usuń' }}
	</button>
</mat-dialog-actions>
